import React, { createContext } from 'react';

const AuthUserContext = createContext({
  user: null,
});

export const useAuth = () => React.useContext(AuthUserContext);

export default AuthUserContext;
